import React, { Component } from "react";
import Package from "../../old_Components/Package/package";
import constant from "../../constant";
import Swal from "sweetalert2";
import {
  PackagesList,
  SubscribedPackageList,
  SubscribePackage,
} from "../../action/package";
import { getStorage } from "../../utils";
import { savePaymentDetail } from "../../action/SubscriptionManagement";
import Loader from "../../old_Components/Common/Loader";

export default class JobPosting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribedList: null,
      packages: undefined,
      showLoader: false,
    };
  }
  componentDidMount() {
    document.title = constant.title.package;

    SubscribedPackageList().then((res) => {
      if (res.status) {
        this.setState({ subscribedList: res.result.all });
      } else {
        // console.log(res.error)
      }
    });
  }

  onSubmit = (model) => {
    debugger;
    // this.setState({ showLoader: true });
    SubscribePackage(model).then((res) => {
      debugger;
      if (res.status) {

        const planAmount = model.AMOUNT;
        this.setState({ showLoader: true });

        const options = {
          key: process.env.REACT_APP_RAZOR_KEY,
          amount: res.result.AMOUNT * 100,
          name: "Job Posting Package",
          description: `${model.PACKAGE_TITLE}`,
          order_id: res.result.ORDER_CREATION_ID,

          handler(razorResponse) {
            debugger
            const paymentId = razorResponse.razorpay_payment_id;
            const data = {
              orderCreationId: res.result.ORDER_CREATION_ID,
              PAYMENT_ID: paymentId,
              SUBSCRIPTION_TXN_ID: res.result.SUBSCRIPTION_TXN_ID,
              razorpayOrderId: razorResponse.razorpay_order_id,
              razorpaySignature: razorResponse.razorpay_signature,
              TXN_STATUS: "SUCCESS",

            };
            if (paymentId) {

              savePaymentDetail(
                //   {
                //   SUBSCRIPTION_TXN_ID: res.result.SUBSCRIPTION_TXN_ID,
                //   PAYMENT_ID: paymentId,
                //   TXN_STATUS: "SUCCESS",
                // }
                data
              ).then((response) => {
                //this.setState({showLoader:false})
                if (response.status) {
                  window.location.href =
                    constant.component.PaymentProcessing.url +
                    "?txn=" +
                    res.result.SUBSCRIPTION_TXN_ID;
                }
              });
            }
          },
          theme: {
            color: "#464646",
          },
        };

        if (model.AMOUNT != 0) {
          const rzp1 = window.Razorpay(options);
          rzp1.open();
        } else {
          Swal.fire({
            text: "Trial plan activated successfully",
            icon: "Success",
          }).then((res) => {
            this.props.history.push(constant.component.Dashboard.url);
          });
        }
      }
      // if (res.status) {
      //   Swal.fire({
      //     icon: 'success',
      //     text: res.result.message,
      //     timer: 1500,
      //     showCancelButton: false,
      //     showConfirmButton: false
      //   })
      //   this.props.history.push(constant.component.Dashboard.url)
      // }
      // else {
      //   Swal.fire({
      //     icon: 'error',
      //     text: res.error,
      //     timer: 1500,
      //     showCancelButton: false,
      //     showConfirmButton: false
      //   })
      // }
    });
  };
  gotoregister = () => {
    this.props.history.push(constant.component.Register.url);
  };

  render() {
    const { subscribedList, packages, showLoader } = this.state;

    return (
      <React.Fragment>
        {
          <Package
            packages={packages}
            subscribedList={subscribedList}
            onSubmit={this.onSubmit}
            gotoregister={this.gotoregister}
          />
        }
        {showLoader && <Loader />}
      </React.Fragment>
    );
  }
}
